import styled from 'styled-components'

const GalleryStyle = styled.div.attrs()`
	margin:var(--sp13x) 0 var(--sp28x);
	position: relative;
	z-index: 3;
	
	section {

		.filter-btns {
			margin:var(--sp7x) 0 0;
			justify-content: flex-end;
			flex-wrap: wrap;

			& > div {
				margin-left:var(--sp4x);
				margin-bottom: var(--sp7x);
				margin-top:0;
			}
		}

		.content {
			width: 100%;
			justify-content: space-between;
			
			.col {
				width: calc(50% - var(--sp2x));
			}
		}
	}

    @media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		margin:var(--sp10x) 0 var(--sp25x);

		section {

			.filter-btns {
				margin:var(--sp6x) 0 0;

				& > div {
					margin-left:var(--sp3x);
					margin-bottom: var(--sp6x);
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		margin:var(--sp9x) 0 var(--sp20x);

		section {

			.filter-btns {
				margin:var(--sp5x) 0 0;

				& > div {
					margin-left:var(--sp3x);
					margin-bottom: var(--sp5x);
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeXS}){
		margin:var(--sp8x) 0 var(--sp18x);

		section {

			.filter-btns {
				margin:var(--sp4x) 0 0;

				& > div {
					margin-left:var(--sp3x);
					margin-bottom: var(--sp4x);
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}){
		margin:var(--sp7x) 0 var(--sp15x);

		section {

			.filter-btns {
				margin:var(--sp3x) 0 0;

				& > div {
					margin-left:var(--sp3x);
					margin-bottom: var(--sp3x);
				}
			}

			@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}){
				.content {
					flex-direction: column;

					.col {
						width: 100%;

						&:nth-child(1) {
							margin-bottom: var(--sp15x);
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		margin:var(--sp6x) 0 var(--sp12x);

		section {

			.filter-btns {
				margin:var(--sp3x) 0 0;

				& > div {
					margin-left:var(--sp3x);
					margin-bottom: var(--sp3x);
				}
			}

			.content {
				flex-direction: column;

				.col {
					width: 100%;
					
					&:nth-child(1) {
						margin-bottom: var(--sp12x);
					}
				}
			}
		}
	}
`
export default GalleryStyle
